import store from '../../store';
import { config } from '../../config';
import { LinkData } from '../../types/response/LinkData';

/** The tab is reserved synchronously, which popup blockers allow when called from a click handler. */
export const openPdf = async (link: LinkData): Promise<void> => {
    const tab = window.open('about:blank', '_blank');

    if (tab) tab.opener = null;

    try {
        const { token } = store.getState().session;

        const response = await fetch(`${config.ApiHost}${link.href}`, {
            method: link.method,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error(response.statusText);

        const url = window.URL.createObjectURL(await response.blob());

        if (tab) tab.location.href = url;
        else window.open(url, '_blank');
    } catch (error) {
        tab?.close();
        throw error;
    }
};
